<template>
    <div class="free-plan-success">
        <cart-nav :options="[ $t('cart_nav.choose_plan'), $t('cart_nav.confirm_details'), $t('cart_nav.complete') ]" :active="2"></cart-nav>
        <div class="logo-wrapper" :style="{backgroundImage: `url(${SuccessImg})`}">
            <img :src="CloudWebSvg" v-if="isCloudPlan">
            <span class="icon icon-co_success_blue" v-else>
                <span class="path1"></span>
                <span class="path2"></span>
            </span>
            <h1 class="content-title">{{ title }}</h1>
        </div>
        <div class="content-wrapper">
            <p class="send-email" v-html="$t('doorbell.contact_us_bind', lang, { link: config.support_team })"></p>
            <slot name="associated-failed"></slot>
        </div>
        <div class="buttons">
            <reo-common-button
                :label="$t('doorbell.back_app')"
                customWidth="100%"
                @click="backApp"
            />
        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { config } from 'CONFIG';
import CloudWebSvg from '@/common/images/common/others/co_cloudweb.png';
import { ESeriesCategory, ESubscribeMode } from '@reolink-cloud/interface';
import nProgress from 'nprogress';
import SuccessImg from 'IMAGE/cart/success.svg';
import { requestToApp } from '@/api/app';

export default Vue.extend({
    props: {
        planType: String as PropType<ESeriesCategory>
    },
    data() {

        return {
            config,
            ESubscribeMode,
            CloudWebSvg,
            SuccessImg
        };

    },
    computed: {
        lang(): string {

            return this.$store.getters.lang;

        },
        title(): string {

            return this.$tc( 'doorbell.associate_success' );

        },
        isCloudPlan(): boolean {

            return this.planType === ESeriesCategory.CLOUD_STORAGE_PLAN;

        }
    },
    mounted() {

        nProgress.done();
        requestToApp( 'completeSubscription', undefined );

    },
    methods:{
        backApp() {

            requestToApp( 'finishPage', undefined );

        }
    }
});
</script>

<style lang="less" scoped>
    .free-plan-success{
        width: 600px;
        margin: 0 auto;
        padding: 0 20px;
        min-height: 100vh;
        @media @snapeak_mobile{
            width: unset;
        }
        /deep/ .wrapper{
            padding: 0;
            .cart-line.active{
                height: 2px;
            }
            .cart-nav-content{
                .active{
                    &::after{
                        background-color: white;
                        border: 2px solid @b_6;
                        height: 6px;
                        width: 6px;
                        margin-top: 4px;
                    }
                }
            }
        }
        .logo-wrapper{
            display: flex;
            flex-direction: column;
            gap: 20px;
            align-items: center;
            justify-content: center;
            margin-bottom: 12px;
            margin-top: 35px;
            background-color: @bg_02;
            border-radius: 12px;
            height: 159px;
            background-repeat: no-repeat;
            background-position: top 29px left 55%;
            img{
                width: 100px;
                height: 100px;
            }
            .content-title{
                font-family: @font_01;
                font-size: 20px;
                font-weight: 600;
                gap: 23px;
                text-align: center;
            }
            .icon{
                color: @b_6;
                font-size: 58px;
            }
        }
        .content-wrapper{
            .send-email{
                margin-top: 16px;
                font-size: 16px;
                font-weight: 500;
                color: @font_secondary;
            }
            margin-bottom: 35px;
        }
    }
</style>
